import AuthService from "./AuthService";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";
const API_URL = `${API_BASE_URL}/api/acupuncture-cards`;

class AcupunctureCardService {
  getByPatientId(patientId) {
    return fetch(`${API_URL}/patient/${patientId}`, {
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }
      return res.json();
    });
  }

  getById(id) {
    return fetch(`${API_URL}/${id}`, {
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }
      return res.json();
    });
  }

  create(card) {
    return fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
      body: JSON.stringify(card),
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }
      return res.json();
    });
  }

  update(id, card) {
    return fetch(`${API_URL}/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
      body: JSON.stringify(card),
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }
      return res.json();
    });
  }

  updateSession(visitId, session) {
    return fetch(`${API_URL}/sessions/${visitId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
      body: JSON.stringify(session),
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }
      return res.json();
    });
  }

  delete(id) {
    return fetch(`${API_URL}/${id}`, {
      method: "DELETE",
      headers: AuthService.getAuthHeader(),
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }
    });
  }
}

export default new AcupunctureCardService();
